// Excellent Plastic Materials Trading LLC — Company branding
// Used in PDF preview, login page, and sidebar.
export const COMPANY = {
  name: "EXCELLENT PLASTIC MATERIALS TRADING LLC",
  shortName: "Excellent Plastic",
  logoSrc: "/logo.png",
  sealSrc: "/seal.png",
  address: "P.O. Box 65188, Dubai – United Arab Emirates",
  poBox: "65188",
  city: "Dubai",
  country: "United Arab Emirates",
  phone: "+971 4 585 2963",
  mobile: "+971 52 885 2963",
  email: "sales@excellentplastic.com",
  website: "www.excellentplastic.com",
  trn: "104032678500003",
  bank: {
    name: "RAK Bank",
    branch: "Dragon Mart",
    accountNo: "0883123760001",
    iban: "AE610400000883123760001",
    swift: "NRAKAEAK",
  },
};
